import { Base } from './base.js';
import { Social } from './social.js';

export class Login extends Base {
    constructor() {
        super();
        this.checkEmailButton = document.querySelector('.check-email-button');
        this.emailInput = document.getElementById('emailInput');
        this.eMailBlock = document.getElementById('eMailBlock');
        this.passwordBlock = document.getElementById('passwordBlock');
        this.forgotPasswordBlock = document.getElementById('forgotPasswordBlock');
        this.btnCheckEmailBlock = document.getElementById('btnCheckEmailBlock');
        this.btnLoginBlock = document.getElementById('btnLoginBlock');
        this.btnSocialLoginGoogle = document.querySelector('.googlebtn');
        this.btn2click = document.querySelector('.check-email-button');
        this.changeEmail = document.querySelector('.change-email');
        this.checkPasswordButton = document.querySelector('#checkLoginButton');
        this.appleSignInBtn = document.querySelector('#appleid-signin #innerButton');
        this.loginCheckTokenForm = document.querySelector('form.loginCheckToken');
        this.plzExists = false;
        this.init();
    }

    init() {

        if (CONFIG.customerId != '') {
            this.decryptGp();
        }

        if (this.isInIframe()) {
            window.parent.postMessage({ height: document.body.scrollHeight }, '*');
        }

        this.pushHistoryState('login');

        if (this.loginCheckTokenForm) {
            this.loginCheckTokenForm.addEventListener('submit', (event) => {
                event.preventDefault();
            });
        }

        if (CONFIG.accessToken && !this.utpCookie) {
            this.utpCookie = CONFIG.accessToken;
            if (CONFIG.tacCookie) {
                this.tacCookie = CONFIG.tacCookie;
                if(CONFIG.environment.isLive == false) { console.log("tacCookie found, it's: " + this.tacCookie); }
                if (!CONFIG.environment.isAudioApp) {
                    // Check if context=gp (Custermer ID required!) and Social Login is used
                    let sentParams = this.getUrlParams();
                    let socialType = ("socialType" in sentParams) ? sentParams.socialType : "";
                    if(CONFIG.environment.isLive == false) { console.log("user logged in, redirecting. Redirect URL: " + this.redirectUrl + " environment context: \"" + CONFIG.environment.context + "\" Social Type: \"" + socialType + "\""); }
                    if (CONFIG.environment.context == "gp" && (socialType == "google" || socialType == "apple")) {
                        if(CONFIG.environment.isLive == false) { console.log("Social Login with Google or Apple, redirecting to enrich Customer ID... Settings in CONFIG: ", CONFIG); }
                        this.hideBlock('#spinnerBlock');
                        this.showBlock('#customerIdBlock');
                        document.querySelector('.main-headline').innerHTML = "Nur noch die Kundennummer...";
                        this.enrichCustomerIdAfterCheck();
                    } else {
                        if(CONFIG.environment.isLive == false) { console.log("Redirecting to redirectUrl without enriching Customer ID, because context is not gp or social login is not google/apple. Settings in CONFIG: "); console.dir(CONFIG); }
                        
                        if (socialType == "google" || socialType == "apple") {
                            if(CONFIG.environment.isLive == false) { console.log("Social login with Google or Apple, but context is not gp, checking for postcode... Settings in CONFIG: ", CONFIG); }
                            this.hideBlock('#spinnerBlock');

                            
                            if(CONFIG.socialLoginGoogleParams.postcodeMissing == false) {
                                if(CONFIG.environment.isLive == false) { console.log("Postcode exists for this email, redirecting to redirectUrl... Settings in CONFIG: ", CONFIG); }
                                document.location.href = this.redirectUrl;        
                            } else {
                                if(CONFIG.environment.isLive == false) { console.log("Postcode does not exist for this email, showing postcode input... Settings in CONFIG: ", CONFIG); }
                                
                                // add postcode to user profile
                                this.showBlock('#postcodeBlock');
                                document.querySelector('#checkPostcodeButton').addEventListener('click', (event) => {
                                    event.preventDefault();
                                    this.hideBlock('.form-error-postcode');

                                    // get email from access token
                                    const payload = this.parseJwt(CONFIG.accessToken);
                                    if(CONFIG.environment.isLive == false) { console.log("JWT Token: ", payload); }

                                    if (payload && payload.email) {
                                        this.emailInput.value = payload.email;
                                        if(CONFIG.environment.isLive == false) { console.log("Email found in JWT token: " + this.emailInput.value); }
                                    } else {
                                        // error handling if email can not be found in token
                                        if(CONFIG.environment.isLive == false) { console.error("Email not found in JWT token."); }
                                        this.errorGpMissing("Token nicht gültig, E-Mail konnte im Token nicht gefunden werden.");
                                        return;
                                    }

                                    let plzValue = document.querySelector('#postcodeInput').value;
                                    // Validierung: nur Zahlen erlaubt, genau 5 Ziffern
                                    if(!/^\d{5}$/.test(plzValue)) {
                                        document.querySelector('.form-error-postcode').innerHTML = "Die Postleitzahl muss aus genau 5 Ziffern bestehen und darf nur Zahlen enthalten.";
                                        this.showBlock('.form-error-postcode');
                                        return;
                                    }
                                    let postcodeRequest = new Request('POST', '/api/addpersonaldata');
                                    postcodeRequest.data = {
                                        email: this.emailInput.value.toLowerCase(),
                                        postcode: plzValue,
                                    };
                                    if(CONFIG.environment.isLive == false) { console.log("Enrich postcode with data: ", postcodeRequest.data); }
                                    postcodeRequest.call(postcodeResponse => {
                                        if (postcodeResponse.status == 'ok') {
                                            if(CONFIG.environment.isLive == false) { console.log("Postcode enriched successfully, redirecting to redirectUrl... Settings in CONFIG: ", CONFIG); }
                                            document.location.href = this.redirectUrl;
                                        } else {
                                            if(CONFIG.environment.isLive == false) { console.log("Error enriching postcode, redirecting to redirectUrl... Settings in CONFIG: ", CONFIG); }
                                            document.querySelector('.form-error-postcode').innerHTML = "Die Postleitzahl konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Leserservice.";
                                            this.showBlock('.form-error-postcode');
                                            return;
                                        } 
                                    }, () => {
                                        if(CONFIG.environment.isLive == false) { console.log("Error enriching postcode (network error), redirecting to redirectUrl... Settings in CONFIG: ", CONFIG); }
                                        document.location.href = this.redirectUrl;
                                    });
                                        
                                });
                            }

                        } else {

                            if(CONFIG.environment.isLive == false) { console.log("User logged in, redirecting without enriching Customer ID. Settings in CONFIG: ", CONFIG); }
                            document.location.href = this.redirectUrl;

                        }
                    }
                } else {
                    document.location.href = "audioapp-shz://open_app?access_token=" + this.utpCookie;
                }
            } else {
                this.updateTacCookie();
            }
        }

        if (this.emailInput) {
            this.emailInput.addEventListener('focus', () => {
                this.hideErrorMessages();
            });

            let regData = Cookies.get('regdata', false);
            if (regData) {
                this.emailInput.value = regData;
                Cookies.remove('regdata', { domain: location.hostname });
            }
        }

        if (this.changeEmail) {
            this.changeEmail.addEventListener('click', () => {
                this.hideAllBlocks();
                this.setStatusbar('25');
                this.showBlock('#eMailBlock');
                this.showBlock('#btnCheckEmailBlock');
                this.checkEmailButton.style.width = "unset";
            });
        }

        if (this.btnSocialLoginGoogle) {
            this.btnSocialLoginGoogle.addEventListener('click', (event) => {
                event.preventDefault();
                let social = new Social();
                social.googleLogin();
            });
        }

        if (this.appleSignInBtn) {
            this.appleSignInBtn.addEventListener('click', (event) => {
                event.preventDefault();
                let social = new Social();
                social.appleLogin();
            });
        }

        if (this.checkEmailButton) {
            this.checkEmailButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.checkEmail();
            });
        }

        if (this.checkPasswordButton) {
            this.checkPasswordButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.checkPassword();
            });
        }

    }

    enterSubmit(event) {
        if (event.key == 'Enter') {
            event.preventDefault();
            if (this.btn2click) {
                this.btn2click.click();
            }
        }
    }

    errorEmail(message) {
        let element = document.querySelector('.form-error-email > p.error');
        if (element) {
            element.innerHTML = message;
            this.showBlock('.form-error-email');
        }
    }

    errorPassword(message) {
        let element = document.querySelector('.form-error-password > p.error');
        if (element) {
            element.innerHTML = message;
            this.showBlock('.form-error-password');
        }
    }

    errorGpMissing(message) {
        let element = document.querySelector('.form-error-customerId > p.error');
        if (element) {
            element.innerHTML = message;
            this.showBlock('.form-error-customerId');
        }
    }

    errorSessionDeleteError(message) {
        let element = document.querySelector('p.errorSessionDelete');
        if (element) {
            element.innerHTML = message;
            this.showBlock('p.errorSessionDelete');
        }
    }

    errorGp(message) {
        let element = document.querySelector('.form-error-customerId > p.error');
        if (element) {
            if (CONFIG.environment.mandant != "om-online") {
                element.innerHTML = message + "<div class='error' style='padding-top:12px;'>Die übermittelte Kundennummer ist " + this.decryptedCustomerId.gp + ", Ihre Kontaktmöglichkeiten zum " + CONFIG.environment.serviceName + " <a href='https://mein." + CONFIG.environment.mandant + ".de/infowelt/kundenservice/kontaktmoeglichkeiten' class='error' style='color:#CC0300' target='_blank'>finden Sie hier &gt;&gt;</a></div>";
            } else {
                element.innerHTML = message + "<div class='error' style='padding-top:12px;'>Die übermittelte Kundennummer ist " + this.decryptedCustomerId.gp + ", Ihre Kontaktmöglichkeiten zum " + CONFIG.environment.serviceName + " <a href='https://www.om-online.de/kontakt' class='error' style='color:#CC0300' target='_blank'>finden Sie hier &gt;&gt;</a></div>";
            }
            this.showBlock('.form-error-customerId');
            this.hideBlock('.check-e-mail-block');
        }
    }

    async sessionsDelete(ssoId, sessions) {
        console.log("Logging out sessions for ssoId " + ssoId + "  :");
        console.dir(sessions);
        this.buttonSpinner(".session-delete");
        let sessionData = {
            ssoId: ssoId,
            sessions: JSON.stringify(sessions),
            email: this.emailInput.value.toLowerCase(),
            password: document.getElementById('passwordInput').value,
        };

        let sessionRequest = new Request('POST', '/api/sessionsDelete');
        sessionRequest.data = sessionData;
        console.log("Calling session delete with data: ", sessionData);
        sessionRequest.call(async response => {
            if (response.status == 'ok') {
                console.log("Sessions deleted, logging out locally...");
                // document.location.href=this.redirectUrl;
                this.checkPassword();
            } else {
                console.error("Error deleting sessions: ", response.message);
                return "error";
                //this.errorPassword(this.errorCode.sessionDeleteError);
            }
        }, () => {
            this.buttonSpinner(".session-delete", false);
            this.errorPassword(this.errorCode.loginError);
        });
    }


    checkEmail() {
        // Temporary check, if email address belongs to any subdomain of bfinv.de
        if (this.emailInput.value != "" && (/^[^@]+@([^.@]+\.)*bfinv\.de$/.test(this.emailInput.value))) {
            this.showPassword();
            return;
        }
        // End of temporary check

        if (this.emailInput.value != "") {
            this.buttonSpinner(".check-email-button");
            this.hideErrorMessages();
            this.emailInput.value = this.emailInput.value.toLowerCase();
            let formData = {
                form: 'pianoEmailcheck',
                email: this.emailInput.value.trim(),
            };

            let request = new Request('POST', '/api/validate/email');
            request.data = formData;
            console.log("Check email with data: ", formData);
            request.call(response => {
                console.log("response...", response);
                if (response.status == 'ok') {
                    if (response.data.valid) {
                        if (CONFIG.customerId != "" && this.decryptedCustomerId.status == "error") {
                            this.buttonSpinner(".check-login-button", false);
                            this.errorGp(this.errorCode.getByCode(this.decryptedCustomerId.value));
                        } else {
                            this.setStatusbar('75');

                            if (response.data.exists) {
                                if(response.data.postcode) {
                                   this.plzExists = true;
                                }
                                this.showPassword();
                            } else {
                                this.showRegister();
                            }
                        }
                    } else {
                        this.errorEmail(this.errorCode.invalidEmail);
                    }
                    this.buttonSpinner(".check-email-button", false);
                } else {
                    this.buttonSpinner(".check-email-button", false);
                    this.errorEmail(this.errorCode.emailError);
                }
            }, () => {
                console.error("Error checking email!");
                this.buttonSpinner(".check-email-button", false);
                this.errorEmail(this.errorCode.emailError);
            });
        } else {
            this.errorEmail(this.errorCode.missingEmail);
        }
    }

    enrichCustomerIdAfterCheck() {
        console.log("Enrich Customer ID after check...");
        let customerIdInputField = document.querySelector('#customerIdInput');
        let checkCustomerIdButton = document.querySelector('#checkCustomerIdButton');
        let lastName = "";
        const payload = this.parseJwt(CONFIG.accessToken);
        console.log("JWT Token: ", payload);

        if (payload && payload.email) {
            this.emailInput.value = payload.email;
        } else {
            // error handling if email can not be found in token
            console.error("Email not found in JWT token.");
            this.errorGpMissing("Token nicht gültig, E-Mail konnte im Token nicht gefunden werden.");
            return;
        }
        if (payload && payload.family_name) {
            lastName = payload.family_name;
        } else {
            // info last name is not in token
            lastName = "";
            console.log("Last name not found in JWT token.");
        }

        checkCustomerIdButton.addEventListener('click', async (event) => {
            event.preventDefault();
            this.buttonSpinner('.check-customerid-button');
            if (customerIdInputField.value != "") {
                let result = await this.validateDecryptedGp(customerIdInputField.value, lastName);
                if (typeof result.status != 'undefined' && result.status == "ok") {
                    console.log("Customer ID is valid: " + customerIdInputField.value);
                    console.log("GP in this.decryptedCustomerId.gp: " + this.decryptedCustomerId.gp + " Status in this.decryptedCustomerId.status: " + this.decryptedCustomerId.status);
                    this.enrichCustomerId(this.redirectUrl);
                } else {
                    console.log("Returned DATA: ", result);
                    this.errorGpMissing(this.errorCode.getByCode(this.decryptedCustomerId.value));
                    this.buttonSpinner('.check-customerid-button', false);
                    return;
                }
            } else {
                this.errorGpMissing(this.errorCode.gpMissingError);
                this.buttonSpinner('.check-customerid-button', false);
            }
        });

    }

    async checkPassword() {
        this.buttonSpinner(".check-login-button");

        let passwordInput = document.getElementById('passwordInput');
        let formData = {
            email: this.emailInput.value.toLowerCase(),
            password: passwordInput.value,
            // deviceLimit: CONFIG.environment.deviceLimit,
        };
        
        let urlParams = this.getUrlParams();
        if (urlParams.watchlistid) {
            formData.bookmark = urlParams.watchlistid;
        }
        
        if(document.querySelector('#plzInput') && document.querySelector('#plzInput').value!=""){
            let plzValue = document.querySelector('#plzInput').value;
            // Validierung: nur Zahlen erlaubt, genau 5 Ziffern
            if(!/^\d{5}$/.test(plzValue)) {
                this.buttonSpinner(".check-login-button", false);
                this.errorPassword("Die Postleitzahl muss aus genau 5 Ziffern bestehen und darf nur Zahlen enthalten.");
                return;
            }
            formData.postcode = plzValue;
            if (CONFIG.environment.isLive != true) { console.log("Postcode added to login data: ", formData.postcode); }
        } else if (this.plzExists != true && document.querySelector('#plzInput') && document.querySelector('#plzInput').value=="") {
            this.buttonSpinner(".check-login-button", false);
            this.errorPassword("Wir benötigen noch Ihre Postleitzahl. Die Postleitzahl muss aus genau 5 Ziffern bestehen und darf nur Zahlen enthalten.");
            return;
        } else {
            formData.postcode = ""; 
        }

        if(CONFIG.environment.isNewsApp){
            formData.origin = "newsApp";
        } else if(CONFIG.environment.isAudioApp){
            formData.origin = "audioApp";
        } else if (CONFIG.environment.isOtherApp){
            formData.origin = "otherApp";
        } else {
            formData.origin = "web";
        }

        let request = new Request('POST', '/api/login');
        request.data = formData;
        request.call(response => {
            if (response.status == 'ok') {
                
                if (response.data.userData) {
                    this.nameless = response.data.userData;
                }

                let redirect = false;
                if (response.data.tac) {
                    this.tacCookie = response.data.tac;
                    redirect = this.redirectUrl;
                }

                if (response.data.accessToken) {
                    this.utpCookie = response.data.accessToken;
                    if (this.missingName) {
                        redirect = this.missingNameRoute;
                    }

                    if (redirect) {
                        if (!CONFIG.environment.isAudioApp) {
                            if (CONFIG.customerId != "" && this.decryptedCustomerId.status == "ok") {
                                this.enrichCustomerId(redirect);
                            }  else if (CONFIG.isNewsApp) {

                                console.log("News App login detected");
                                // Dynamischer Import nur wenn benötigt
                                import('web2native2web/web2native').then(({ Web2Native }) => {
                                    Web2Native.User.setToken({token: response.data.accessToken});
                                    console.log("News App login, token " + response.data.accessToken + " sent to native app.");
                                    document.location.href = redirect;
                                }).catch(error => {
                                    console.error("Error loading Web2Native module:", error);
                                });

                            } else {
                                // default redirect after successful login
                                this.performRedirect(redirect)
                                // document.location.href = redirect;
                            }
                        } else {
                            document.location.href = "audioapp-shz://open_app?access_token=" + this.utpCookie;
                        }
                    } else {
                        this.updateTacCookie();
                    }
                } else {
                    this.errorPassword(this.errorCode.cookieSet);
                    this.buttonSpinner('.check-login-button', false);
                }
            } else {
                this.buttonSpinner(".check-login-button", false);
                if (response.code == 10010) {
                    let deviceLimitBlock = document.getElementById('deviceLimitBlock');
                    if (deviceLimitBlock) {
                        deviceLimitBlock.style.cssText = "";
                        let sessionHtml = '';
                        Object.values(response.data.sessions).forEach(session => {
                            sessionHtml += '<div class="session session-' + session.id + '"><span class="session-device"><span title="Deteils zum verwendeten Gerät">' + session.device + '</span> – <span title="Letzte Aktivität des Geräts">' + session.lastActivity + '</span></span><button class="btn session-logout" type="button" title="Dieses Gerät entfernen" data-session-id="' + session.id + '"><span class="inakt">Entfernen</span><span class="d-none akt">Wird entfernt</span></button><input type="hidden" name="session-' + session.id + '-checkbox" class="session-checkbox" value="' + session.id + '" aria-checked="false" tabindex="0"></div>';
                        });
                        sessionHtml += '<button class="session-delete btn" role="button" tabindex="0" title="Markierte Geräte entfernen" aria-pressed="false"><span class="session-delete-text btn-text">Markierte Geräte entfernen</span><div class="lds-ellipsis spinnerActive d-none"><div></div><div></div><div></div><div></div></div></button>';
                        document.querySelector('.session-list').innerHTML = sessionHtml;

                        if (document.querySelectorAll('.session-logout').length > 0) {

                            // Alle Session-Logout-Buttons auswählen
                            const sessionButtons = document.querySelectorAll('.session-logout');
                            sessionButtons.forEach(function (button) {
                                button.addEventListener('click', function () {
                                    // Die beiden span-Tags im Button finden
                                    const inaktSpan = button.querySelector('.inakt');
                                    const aktSpan = button.querySelector('.akt');
                                    // Toggle-Logik
                                    if (!button.classList.contains('delete')) {
                                        // Zustand: Wird entfernt anzeigen
                                        inaktSpan.classList.add('d-none');
                                        aktSpan.classList.remove('d-none');
                                        button.classList.add('delete');
                                    } else {
                                        // Zustand zurücksetzen
                                        inaktSpan.classList.remove('d-none');
                                        aktSpan.classList.add('d-none');
                                        button.classList.remove('delete');
                                    }
                                });
                            });
                        }

                        // Klick-Handler für das "Markierte Geräte entfernen"-Div
                        const deleteDiv = document.querySelector('.session-delete');
                        if (deleteDiv) {
                            deleteDiv.addEventListener('click', () => {
                                // Alle Buttons mit Klasse 'delete' finden
                                const deleteButtons = document.querySelectorAll('.session-logout.delete');
                                const sessionIds = [];
                                deleteButtons.forEach(function (btn) {
                                    // Das zugehörige Input-Feld mit der Klasse 'session-checkbox' suchen
                                    const input = btn.nextElementSibling;
                                    if (input) {
                                        sessionIds.push(input.value);
                                    }
                                });
                                if (sessionIds.length === 0) {
                                    console.log("No sessions selected for deletion. Frontend error output missing here!");
                                    return;
                                }
                                // Hier können Sie die sessionIds verwenden, um die Sessions zu löschen
                                console.log("User: ", response.data.ssoId, " wants to delete sessions: ", sessionIds);
                                let deleteResult = this.sessionsDelete(response.data.ssoId, sessionIds);
                                if (deleteResult === 'error') {
                                    this.errorSessionDeleteError('Fehler beim Entfernen der ausgewählten Geräte. Bitte versuchen Sie es erneut.');
                                } else {
                                    console.log("Sessions deleted successfully");
                                }
                            });
                        }

                    } else {
                        this.errorPassword(this.errorCode.getByCode(response.code));
                    }
                } else {
                    this.errorPassword(this.errorCode.getByCode(response.code));
                }
            }
        }, () => {
            this.buttonSpinner(".check-login-button", false);
            this.errorPassword(this.errorCode.loginError);
        });
    }

    showRegister() {
        this.buttonSpinner(".check-login-button");
        Cookies.set('regdata', this.emailInput.value.toLowerCase(), { domain: location.hostname });
        if (CONFIG.customerId != "" && this.decryptedCustomerId.status == "ok") {
            Cookies.set('submittedGp', this.decryptedCustomerId.gp, { domain: location.hostname });
        }
        window.location.href = this.registerRoute;
    }

    showPassword() {
        this.hideAllBlocks();
        this.passwordBlock.querySelector('.email-text-bold').innerHTML = this.emailInput.value;
        if (CONFIG.environment.isLive != true) { console.log("plzExists? " + this.plzExists); }
        if (this.plzExists) {
            const plzInputGroup = this.passwordBlock?.querySelector('.plzInputGroup');
            if (plzInputGroup) {
                plzInputGroup.innerHTML = "";
                // this.showBlock(plzInputGroup);
            } else {
                console.warn('plzInputGroup element not found in passwordBlock');
            }
        }
        // if (this.plzExists) {
        //     this.passwordBlock.querySelector('.plzInputGroup').innerHTML = "Ihre Postleitzahl ist bereits bei uns hinterlegt und Sie erhalten Nachrichten aus Ihrer Region. Sie können Ihre Postleitzahl nach Anmeldung in Ihrem Benutzerportal jederzeit ändern.";
        //     // this.showBlock(this.passwordBlock.querySelector('.plzInputGroup'));
        // }
        if (CONFIG.customerId != "" && this.decryptedCustomerId.status == "ok") {
            this.passwordBlock.querySelector('.customerId-text').innerHTML = "Kundennummer: " + this.decryptedCustomerId.gp;
        }
        this.showBlock(this.passwordBlock);
        this.showBlock(this.forgotPasswordBlock);
        this.showBlock(this.btnLoginBlock);
        this.btn2click = document.querySelector('#checkLoginButton');
    }
}